<template>
    <v-col cols="12" sm="auto" md="auto" style="cursor:pointer;">
        <v-card class="kicker"
                v-scroll-to="'#courses'"
                elevation="4"
                color="purple"
                dark>
            <div style="float:right;" class="ma-0 mt-2 mr-1">
                <span v-if="HasCompletedAllRegistrations"
                      class="fa-stack fa-lg">
                    <i class="fas fa-circle fa-stack-2x icon-success"></i>
                    <i class="fas fa-check fa-stack-1x"></i>
                </span>
                <span v-else
                      class="fa-stack fa-lg">
                    <i class="fas fa-circle fa-stack-2x icon-error"></i>
                    <i class="fas fa-exclamation fa-stack-1x"></i>
                </span>
            </div>
            <v-card-title>Your Course{{ ActiveEnrolments.length > 1 ? 's' : '' }}</v-card-title>
            <v-card-text>
                <p v-if="HasCompletedAllRegistrations" class="ma-0">You have successfully enrolled</p>
                <p v-else-if="!HasStartedAnyRegistrations" class="ma-0">Begin your enrolment</p>
                <p v-else class="ma-0">Continue your enrolment</p>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
    import { eventBus } from '@/main'

    import studentsMixin from '@/views/components/mixins/enterpriseDataApi/students.js'
    import enrolmentsMixin from '@/views/components/mixins/enterpriseDataApi/enrolments.js'
    import enrolmentRegistrationsMixin from '@/views/components/mixins/enrolmentRegistrations.js'
    import inductionAttendanceMixin from '@/views/components/mixins/inductionAttendance.js'

    export default {
        props: ['constants', 'student', 'enrolments', 'enrolmentRegistrations'],
        mixins: [
            studentsMixin,
            enrolmentsMixin,
            enrolmentRegistrationsMixin,
            inductionAttendanceMixin,
        ],
        mounted() {
            eventBus.$off('enrolment-registrations-fetch:started').$on('enrolment-registrations-fetch:started', () => this.loading = true);
            eventBus.$off('enrolment-registrations-fetch:finished').$on('enrolment-registrations-fetch:finished', () => this.loading = false);
            eventBus.$on('induction-attendance-save:success', () => this.LoadInductionAttendances(this.student.StudentID));

            this.LoadInductionAttendances(this.student.StudentID);
        },
    }
</script>
